/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsFrontendService
 */

export const SuccessfulReplyRecommendationResponseTypename = 'com.hubspot.cv.replies.models.generation.SuccessfulReplyRecommendationResponse';
export const UnsuccessfulReplyRecommendationResponseTypename = 'com.hubspot.cv.replies.models.generation.UnsuccessfulReplyRecommendationResponse';
export const getReplyRecommendationsWithReasonRpc = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsFrontendService',
  rpcName: 'getReplyRecommendationsWithReason',
  auth: 'app',
  fingerprint: 'GOz7cFCaJWJQWy76_m42pAXsW9GokRuR',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};